@if (isLoading) {
    <guarda-digital-loader></guarda-digital-loader>
  }

<router-outlet [style]="isLoading ? 'display: none' : 'display: block'"></router-outlet>